module.exports = __webpack_public_path__ + "media/images/carousel-left-f0981a0f.png";